/**
 * This function receives a string and add escapes regex escape char.
 * It is useful to convert a string into a regex expression.
 *
 * @param {string} v
 * @returns string Received values with regex escape
 */
export const regExpEscape = (v) => v.replace(/([.*+?^$|(){}[\]])/gm, '\\$1');
